import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-336">
      <div className="max-w-4xl mx-auto text-center" data-id="element-337">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00E676]/50 text-[#00E676] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-338">
          🏆 Sistema N°1 para Docentes de Biología en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-339">
          🧬 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#00E676] mb-6" data-id="element-340">
          MEGAPACK BIOLOGÍA LISTA
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-341">
          <strong data-id="element-342">
            6 Tomos + 6 Bonos — 1º a 6º año de secundaria — Todo resuelto.
          </strong>
          <br data-id="element-343" />
          360 páginas de contenido curricular completo. Solucionario en cada
          tomo. Planificación anual lista para presentar. Listo para usar desde
          hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-344">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-345">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: color,
            border: '2px solid #00E676'
          }} data-id="element-346">
                <span className="text-white text-xs font-bold" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-347">
                  {i + 1}°
                </span>
              </div>)}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00E676] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-348">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-349">
          <span className="bg-[#00E676]/10 border border-[#00E676]/40 text-[#00E676] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-350">
            ✅ Por año
          </span>
          <span className="bg-[#00E676]/10 border border-[#00E676]/40 text-[#00E676] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-351">
            ✅ Con planificación anual lista
          </span>
          <span className="bg-[#00E676]/10 border border-[#00E676]/40 text-[#00E676] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-352">
            ✅ Con solucionario completo
          </span>
          <span className="bg-[#00E676]/10 border border-[#00E676]/40 text-[#00E676] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-353">
            ✅ Con evaluaciones y rúbricas
          </span>
          <span className="bg-[#00E676]/10 border border-[#00E676]/40 text-[#00E676] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-354">
            ✅ Con bonos incluidos
          </span>
          <span className="bg-[#00E676]/10 border border-[#00E676]/40 text-[#00E676] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-355">
            ✅ Con contenidos de ESI integrados
          </span>
        </div>
      </div>
    </section>;
}